import { render, staticRenderFns } from "./WorkDetail3.vue?vue&type=template&id=4e60701e&scoped=true&"
import script from "./WorkDetail3.vue?vue&type=script&lang=js&"
export * from "./WorkDetail3.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail3.vue?vue&type=style&index=0&id=4e60701e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60701e",
  null
  
)

export default component.exports